import { EnterActionDirective } from '../../../../../../shared/directive/enter-action.directive';
import { AutofocusDirective } from '../../../../../../shared/directive/autofocus.directive';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  FormArray,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/base-components';
import isEqual from 'lodash/isEqual';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import {
  getMaxBirthDate,
  getMinAnimalBirthDate,
} from '@anihis/shared/src/validators/birth-date.validators';

@Component({
  selector: 'anihis-clinic-observation-dog-rabies',
  standalone: true,
  imports: [
    EnterActionDirective,
    AutofocusDirective,
    CommonModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  templateUrl: './clinic-observation-dog-rabies.component.html',
  styleUrl: './clinic-observation-dog-rabies.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClinicObservationDogRabiesComponent
  extends FormBaseComponent
  implements OnInit, AfterViewInit
{
  minDate = getMinAnimalBirthDate();
  today = getMaxBirthDate();

  @ViewChildren(MatDatepicker) datePickers!: QueryList<MatDatepicker<any>>;
  datePickerRefs: MatDatepicker<any>[] = [];
  @Output() formChange = new EventEmitter<any>();
  override ngOnInit() {
    this.form = this.fb.group({
      observations: this.fb.array([this.createObservationGroup()]),
      note: [''],
      veterinarianName: [''],
    });

    this.form.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(isEqual))
      .subscribe((value) => {
        this.formChange.emit(value);
      });
  }

  ngAfterViewInit() {
    this.datePickerRefs = this.datePickers.toArray();
  }

  get observations() {
    return this.form.get('observations') as FormArray;
  }

  createObservationGroup(): FormGroup {
    return this.fb.group({
      date: [null, Validators.required],
      finding: ['', Validators.required],
    });
  }

  addObservation() {
    this.observations.push(this.createObservationGroup());
    this.updateDatePickerRefs();
  }

  removeObservation(index: number) {
    this.observations.removeAt(index);
    this.updateDatePickerRefs();
  }

  clearForm() {
    this.form.reset();
    this.observations.clear();
    this.addObservation();
    this.updateDatePickerRefs();
  }

  updateDatePickerRefs() {
    setTimeout(() => {
      this.datePickers.forEach((picker, index) => {
        this.datePickerRefs[index] = picker;
      });
    });
  }

  handlePathClick(pathNumber: number) {
  }
}
